namespace JupitersChoice {
    export class CheckJupitersChoiceCmd {

        @inject('ComponentManager') _componentManager: Sapphire.ComponentManager;
        @inject('GameConfig') _config: Sapphire.GameConfig;
        @inject('EventManager') _eventManager: Sapphire.EventManager;
        @inject('GameServer') _gameServer: Sapphire.GameServer;
        @inject('StateModel') _stateModel: Sapphire.StateModel;

        execute(): void {
            const response: any = this._gameServer.logicResponse;
            const grids = this._config.get('external', 'grids');
            const spinInfo = this._stateModel.currentSubgame === 'FreeGame' ?
                response.freespins[ShowFreeGameCmd.currentFreeGameSpinIdx - 1] : response;
            const reelsetType = grids[spinInfo.grid].reels;
            const reels = this._componentManager.get('Reels');
            var hasJupitersChoice = response.lockedWithPreviousReel.filter((bool) => {
                return bool === true;
            }).length > 0;

            // make sure reels are using correct reelset
            for (let i = 0; i < 6; i++) {
                let reelset = reelsetType[spinInfo.rawReelIndices[i]];
                let startingIdx = Math.floor(Math.random() * reelset.length);
                reels.updateStrip(i, reelset, false, startingIdx);
            }

            if (!hasJupitersChoice) {
                TweenMax.delayedCall(0.7, () => {
                    this._eventManager.publish('onHasNoJupitersChoice');
                });
            } else {
                TweenMax.delayedCall(0.7, () => {
                    this._eventManager.publish('onHasJupitersChoice');
                });
            }
        }
    }
}